import { Injectable } from '@angular/core';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';

@Injectable()

export class BarcodeScannerService {

  private html5QrcodeScanner;

  public scanning = false;

  private modals;

  constructor() {
  }

  public scan(options?: any){
    this.html5QrcodeScanner = new Html5QrcodeScanner(
      "html5qr-code-full-container",
      {
        fps: 10,
        qrbox: {width: 300, height: 300},
        rememberLastUsedCamera: false,
        supportedScanTypes: [ Html5QrcodeScanType.SCAN_TYPE_CAMERA ]
      }, false);
    this.modals = document.querySelectorAll('.show-page');
    return new Promise<any>((resolve, reject) => {
      this.scanning = true;
      // hide modals
      this.modals.forEach((element) => {
        element.classList.add('hide-modal');
      });
      this.html5QrcodeScanner.render((content) => {
        this.stop();
        console.log('BarcodeScannerService.scan: ' + content);
        let data = { text: content };
        resolve(data);
      }, (error) => {
        console.error(error);
      });
    });
  }

  public stop(){
    if(this.modals){
      this.modals.forEach((element) => {
        element.classList.remove('hide-modal');
      });
    }
    this.scanning = false;
    this.html5QrcodeScanner.clear();
  }

}



// WEBPACK FOOTER //
// ./src/services/barcode-scanner.service.ts